export class LanguageService {
    constructor(supportedLanguages) {
        this._supportedLanguages = supportedLanguages;
    }

    get SupportedLanguages() {
        return this._supportedLanguages;
    }

    getLocale(language, dialect) {
        if (!language || !dialect) return {};

        const code = dialect.localeCode || `${language.langCode}-${dialect.dialectCode}`;
        return {
            code,
            langCode: language.langCode,
            langText: language.langText,
            dialectCode: dialect.dialectCode,
            dialectText: dialect.dialectText,
            dialectVoice: dialect.dialectVoice,
            translationCode: dialect.translationCode,
            transcriptionDir: language.transcriptionDir,
        };
    }
}
